import { ChatUser } from "@virtualprogaming/js-public-sdk";
import React, { FC } from "react";

import { getImageIdFromTags } from "~/utils";

import { CDNImage, ImageVariant } from "../../cdnImage";

interface ChatUsersImageProps {
  user: ChatUser;
}

export const ChatUsersImage: FC<ChatUsersImageProps> = ({ user }) => {
  let imageId = "";
  if (user?.tags) {
    imageId = getImageIdFromTags(user.tags);
  }

  return imageId !== "" && imageId !== "None" ? (
    <CDNImage
      imageId={imageId}
      variant={ImageVariant.XLThumbnail}
      className="borderR-circle"
      height={38}
      width={38}
    />
  ) : (
    <img
      alt="user"
      src={user.avatar_url}
      height={38}
      width={38}
      className="borderR-circle"
    />
  );
};
